import env from './runtime';

const {
    REACT_APP_VASLOLA_FRONTEND_PUBLIC_URL,
    REACT_APP_VASLOLA_FRONTEND_PUBLIC_URL_BACK,
    REACT_APP_VASLOLA_BASENAME,
    REACT_APP_VASLOLA_FRONTEND_AUTH_CLIENT_ID,
    REACT_APP_VASLOLA_CONTACT_WHATSAPP,
    REACT_APP_VASLOLA_CONTACT_EMAIL,
    REACT_APP_VASLOLA_WSS_URL,
    REACT_APP_VASLOLA_WSS_PATH
} = env;

const config = {
    URL: {
        VASLOLA_APP_URL: REACT_APP_VASLOLA_FRONTEND_PUBLIC_URL,
        VASLOLA_APP_URL_BACK: REACT_APP_VASLOLA_FRONTEND_PUBLIC_URL_BACK,
        BASENAME: REACT_APP_VASLOLA_BASENAME,
        WSS_URL: REACT_APP_VASLOLA_WSS_URL,
        WSS_PATH: REACT_APP_VASLOLA_WSS_PATH,
        API_BASE_URL: env.REACT_APP_VASLOLA_API_BASE_URL || REACT_APP_VASLOLA_FRONTEND_PUBLIC_URL,
        API_BASE_PATH: env.REACT_APP_VASLOLA_API_BASE_PATH,
        AUTH_BASE_PATH: env.REACT_APP_VASLOLA_AUTH_BASE_PATH,
    },

    VASLOLA_AUTH_CLIENT_ID: REACT_APP_VASLOLA_FRONTEND_AUTH_CLIENT_ID,
    VASLOLA_CONTACT_WHATSAPP: REACT_APP_VASLOLA_CONTACT_WHATSAPP,
    VASLOLA_CONTACT_EMAIL: REACT_APP_VASLOLA_CONTACT_EMAIL,
};

export default config;
